const DEFAULT_INTERVAL = 1000;
const JITTER = 250;
/** 每次轮询顺带清理的旧信号阈值（毫秒），由 Worker 侧处理。 */
const CLEANUP_AGE_MS = 5 * 60 * 1000;
export class PollingSignalingChannel {
    #opts;
    #timer = null;
    #cursor = 0;
    #running = false;
    #inFlight = false;
    #state = "idle";
    #consecutiveErrors = 0;
    #playerSeen = false;
    constructor(opts) {
        this.#opts = opts;
    }
    get state() {
        return this.#state;
    }
    get cursor() {
        return this.#cursor;
    }
    start(after = 0) {
        if (this.#running)
            return;
        this.#running = true;
        this.#cursor = after;
        this.#setState("waiting");
        void this.#loop();
    }
    stop() {
        this.#running = false;
        if (this.#timer)
            clearTimeout(this.#timer);
        this.#timer = null;
        this.#setState("closed");
    }
    /**
     * 握手完成，停止轮询（控制 D1 读配额，技术方案 §5.2 轮询纪律）。
     * 之后改由 `GET /api/rooms/:id` 低频感知 HOST_LOST。
     */
    markConnected() {
        this.#running = false;
        if (this.#timer)
            clearTimeout(this.#timer);
        this.#timer = null;
        this.#setState("connected");
        this.#opts.onConnected?.();
    }
    /**
     * 重连场景：从当前 cursor 恢复轮询（不重置游标，不重放旧信号）。
     * 若已 stop() 过则保持停止。
     */
    resume() {
        if (this.#running || this.#state === "closed")
            return;
        this.#setState("waiting");
        void this.#loop();
    }
    send(msg) {
        void this.#opts.api.signal(this.#opts.roomId, this.#opts.token, msg).catch((err) => {
            this.#opts.events.onError?.(err);
        });
    }
    #setState(s) {
        if (this.#state === s)
            return;
        this.#state = s;
        this.#opts.events.onState?.(s);
    }
    async #loop() {
        if (!this.#running || this.#inFlight)
            return;
        this.#inFlight = true;
        try {
            const res = await this.#opts.api.sync(this.#opts.roomId, this.#opts.token, this.#cursor);
            this.#consecutiveErrors = 0;
            this.#cursor = res.since;
            this.#opts.events.onStatus?.(res.status);
            const players = res.players.filter((p) => p.role === "player");
            this.#opts.events.onPlayers?.(players);
            if (players.length === 0)
                this.#playerSeen = false;
            if (players.length > 0 && !this.#playerSeen) {
                this.#playerSeen = true;
                this.#opts.events.onPlayerJoined?.();
                this.#setState("handshaking");
            }
            for (const s of res.signals) {
                const msg = s.message;
                this.#opts.events.onSignal(msg);
            }
        }
        catch (err) {
            this.#consecutiveErrors += 1;
            this.#setState("error");
            this.#opts.events.onError?.(err);
            if (this.#consecutiveErrors >= 5) {
                this.#running = false;
                return;
            }
        }
        finally {
            this.#inFlight = false;
        }
        if (!this.#running)
            return;
        const interval = this.#opts.intervalMs ?? DEFAULT_INTERVAL;
        const delay = interval + Math.floor(Math.random() * JITTER);
        this.#timer = setTimeout(() => void this.#loop(), delay);
    }
    get cleanupAgeMs() {
        return CLEANUP_AGE_MS;
    }
}
//# sourceMappingURL=polling.js.map